import { languages } from '../constants/languages';

const categoriesData = {
  [languages.FINNISH]: ['ohjelmistokehitys', 'liiketoiminta'],
  [languages.ENGLISH]: ['software development', 'business'],
};

export default categoriesData;
